export default {
      id: "chevron-up-usage",
      viewBox: "0 0 14.054 7.426",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#chevron-up",
      toString: function () {
        return this.url;
      }
    }